import { useModal } from '@shared/model/useModal';

export const useHowActiveReferralModal = () => useModal('how-active-referral-modal')